import { InfoType } from '../lib/InputInfoBox/InputInfoBoxUI';
import { IInputPrimaryState } from './input.model';
import { InputStateVariant } from '@axo/ui-core/components/input/InputProps.types';

export const UIInputState: Record<IInputPrimaryState, InputStateVariant> = {
  undetermined: 'neutral',
  'undetermined-with-tooltip': 'neutral',
  loading: 'neutral',
  disabled: 'neutral',
  'soft-invalid': 'warn',
  invalid: 'error',
  valid: 'success',
} as const;

export const UIValidationState: Record<InfoType, InputStateVariant> = {
  error: 'error',
  warning: 'warn',
  tooltip: 'neutral',
  success: 'success',
} as const;

// legacy to legacy 😬
export const legacyInfoToPrimaryState: Record<InfoType, IInputPrimaryState> = {
  error: 'invalid',
  warning: 'soft-invalid',
  tooltip: 'undetermined',
  success: 'valid',
} as const;
